module.exports = __webpack_public_path__ + "static/assets/d9b5c12128a5fa635f099c4292860054.svg";